import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import PersonSearch from 'shell/components/shared/person-search';
import ActionsList from 'mutation/components/registration-marriage/actions-list';
import { SearchPersonMarriageCrumbs } from 'mutation/constants/registration-marriage-crumbs';

const PersonsPage = (): React.ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={SearchPersonMarriageCrumbs} />
      <PersonSearch
        pathname="/mutazioni/persona/matrimonio/residenti/registrazione"
        action={ActionsList}
        addedTitle={'- Registrazione Matrimonio'}
      />
    </Fragment>
  );
};

PersonsPage.displayName = 'Persons page component';

export default PersonsPage;
